/* ES gclid -> cart permalink attribute. Added 2026-07-30.

   WHY THIS EXISTS:
   The Florence and Linen Kit landing pages render with `layout none`, so
   layout/theme.liquid never runs and snippets/es-gclid-capture.liquid is never
   rendered on them. Those two pages are also the only pages built to receive
   Google Ads traffic. On top of that, their buy button is a CART PERMALINK
   (/cart/<variantId>:<qty>), which REPLACES the cart - so even a _gclid stamped
   on a previous cart would be discarded at checkout.

   Shopify cart permalinks do accept attributes[key]=value, so this appends the
   Google click id directly to every /cart/ link at click time. The attribute
   lands in the order's note_attributes, where the Shopify orders/create webhook
   -> server GTM -> Google Ads conversion tag reads it.

   SAFETY: purely additive. With no click id present no listener is registered
   and no URL is ever altered. Every step is wrapped in try/catch so a failure
   here can never block a purchase. */
(function () {
  function clean(v) { return v && /^[A-Za-z0-9_-]{8,200}$/.test(v) ? v : ''; }

  function fromCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]+)/);
      if (!m) return '';
      var p = decodeURIComponent(m[1]).split('.');
      return p.length >= 3 ? clean(p[p.length - 1]) : '';
    } catch (e) { return ''; }
  }

  var ids = {};
  try {
    var sp = new URLSearchParams(location.search);
    // Validate each candidate independently so a malformed gclid cannot
    // suppress a valid backup_gclid (the account-level final_url_suffix
    // sends backup_gclid={gclid} precisely as the redundancy layer).
    var g = clean(sp.get('gclid')) || clean(sp.get('backup_gclid')) || fromCookie();
    var gb = clean(sp.get('gbraid'));
    var wb = clean(sp.get('wbraid'));
    if (g) ids._gclid = g;
    if (gb) ids._gbraid = gb;
    if (wb) ids._wbraid = wb;
  } catch (e) {}

  var keys = Object.keys(ids);
  if (!keys.length) return;

  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/cart/"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('attributes[_gclid]') !== -1 || href.indexOf('attributes%5B_gclid%5D') !== -1) return;
      var add = keys.map(function (k) {
        return 'attributes[' + k + ']=' + encodeURIComponent(ids[k]);
      }).join('&');
      a.setAttribute('href', href + (href.indexOf('?') >= 0 ? '&' : '?') + add);
    } catch (err) {}
  }, true);
})();
